module.exports = __webpack_public_path__ + "static/assets/27f90bfa982840e56c3ad207561193fa.svg";